/* Status badge utility */
export function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`badge status-${status}`}
    >
      {status}
    </span>
  );
}

export function formatCurrency(amount, currency = "UGX") {
  const value = Number(amount || 0);
  if (currency === "USD" || currency === "EUR" || currency === "GBP") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  }
  return `${currency} ${value.toLocaleString()}`;
}

export function formatDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return d;
  }
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const ms = new Date(dateStr).getTime() - Date.now();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}
